import React from 'react';
import ProjectDetailContainer from '@src/containers/ProjectDetail';

const ProjectDetail = () => <ProjectDetailContainer />;

export default ProjectDetail;
